module.exports = __webpack_public_path__ + "static/media/downArrow.c1a9f427.svg";